import { ApiClient } from '@api/api-configuration';
import { captureError } from '@app/lib/Sentry';
import { useMutation } from '@tanstack/react-query';

// Only the API calls are here
export const useMarkNotifications = () => {
  const markNotificationAsReadMutation = useMutation({
    mutationFn: ({ notificationId }: { notificationId: number }) =>
      ApiClient.notificationsApi.notifications.updateNotification(notificationId, {
        isRead: true,
      }),
    onSuccess: () => {
      // openNotification('topRight', {
      //   title: `Service Request`,
      //   description: 'Visit created successfully. ',
      //   type: 'Success',
      // });
    },
    onError: (error) => {
      captureError(error as Error, { context: 'Mark single notification as read' });
      // TODO : IN any case there is a BE error we need to roll back the UI state.
      // roll back
    },
  });

  const markAllNotificationAsReadMutation = useMutation({
    mutationFn: ({ userId }: { userId: number }) =>
      ApiClient.notificationsApi.notifications.markAllNotificationsRead(userId),
    onSuccess: () => {
      // openNotification('topRight', {
      //   title: `Service Request`,
      //   description: 'Visit created successfully. ',
      //   type: 'Success',
      // });
    },
    onError: (error) => {
      captureError(error as Error, { context: 'Mark all notifications as read' });
      // TODO : IN any case there is a BE error we need to roll back the UI state.
    },
  });

  const markSingleNotificationAsRead = ({ notificationId }: { userId: number; notificationId: number }) => {
    markNotificationAsReadMutation.mutate({
      notificationId,
    });
  };

  const markAllNotificationsAsRead = ({ userId }: { userId: number }) => {
    markAllNotificationAsReadMutation.mutate({
      userId,
    });
  };

  return {
    markSingleNotificationAsRead,
    markAllNotificationsAsRead,
    isMarkAsReadNotificationPending: markNotificationAsReadMutation.isPending,
    isMarkAllAsReadNotificationPending: markAllNotificationAsReadMutation.isPending,
  };
};

export default useMarkNotifications;
